export default __webpack_public_path__ + "static/media/card-tenant.0f5dfd6a.png";